import axios from 'axios'
import {settings} from './variables.js';
// import { data } from 'jquery';

var baseUrl = settings.apiBaseUrl

window.renderFacetsActions = function () {

    const relativeUrl = window.location.pathname
    // const relativeUrl = '/catalog/sejfyi/'
    const facetsForm = document.getElementById('facets_form')

    if (!facetsForm) {
        return false
    }

    const facetsContainer = document.getElementById('facets_container')
    const productsContainer = document.getElementById('products_container')
    const paginationContainer = document.getElementById('pagination_container')

    facetsForm.addEventListener('change', (eventForm) => {

        facetsForm.classList.add('char-facets__form--loading-process')

        var formData = new FormData(facetsForm)
        var getUrlsParts = []

        for (const pair of formData.entries()) {

            getUrlsParts.push(`${pair[0]}=${pair[1]}`)
            
        }

        var resultGetUrl = getUrlsParts.join('&')

        axios.get(`${baseUrl}${relativeUrl}?is_ajax=1&${resultGetUrl}`).then(
            response => {
                var facets = response.data.facets
                var products = response.data.products
                var pagination = response.data.pagination

                facetsContainer.innerHTML = facets
                productsContainer.innerHTML = products
                paginationContainer.innerHTML = pagination

                renderFacetsActions()
                collapseFacets()

                history.replaceState({facets: resultGetUrl}, 'fsf', `${relativeUrl}?${resultGetUrl}`)

                facetsForm.classList.remove('char-facets__form--loading-process')
            }
        )
    })
}


renderFacetsActions()
